import { MenuPresets } from '@framework/form/inputs/rich-text/menu/MenuPresets.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import styled from 'styled-components';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput.tsx';
import { useTreeReferencesContext } from '../../../../../tree/references/TreeReferencesContext.tsx';
import { ConditionGroupInput } from '../../../../expressions/repository/condition-group/input/ConditionGroupInput.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { LayoutHideConfigInput } from '../../common/config/LayoutHideConfigInput.tsx';
import { CodeLabelInputForm } from '../../inputs/common/CodeLabelInputForm.tsx';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type ComputedWidget } from '../IComputedWidget.ts';

const InputBorder = styled.div`
  border: 1px solid ${props => props.theme.colorBorder};
  border-radius: 6px;
  padding: 8px;
`;

type IComputedBooleanConfigComponentProps =
  IWidgetComponentProps<ComputedWidget>;

export function ComputedBooleanConfigComponent(
  props: IComputedBooleanConfigComponentProps,
) {
  const options = getWidgetProps(props);
  const { references } = useTreeReferencesContext();

  return (
    <div>
      {/* Form Codice + Etichetta */}
      <CodeLabelInputForm widgetOptions={options} />

      <FormItem name="text" label="Testo">
        <RichTextAdvancedInput
          name="text"
          rows={2}
          menus={MenuPresets.Minimal}
        />
      </FormItem>

      <FormItem name="expression" label="Espressione">
        <InputBorder>
          <ConditionGroupInput name={`expression`} references={references} />
        </InputBorder>
      </FormItem>

      <LayoutHideConfigInput />
    </div>
  );
}
